export const onExpDateChange = (e: { [key: string]: any }): string => {
  const {
    target: { value },
  } = e;
  let expDate = '';
  switch (true) {
    case value.length === 2 && value <= 12:
      expDate = value.padEnd(3, '/');
      return expDate;
    case value.length === 2 && +value > 12:
      expDate = '12'.padEnd(3, '/');
      return expDate;
    case value.length <= 5:
      expDate = value;
      return expDate;
    default:
      return expDate;
  }
};
